import React, { useState } from 'react';
import Seo from '../components/Seo';

const ContentPage = ({
  title,
  description,
  h1,
  canonical,
  content = [],
  ctaText = 'Get a Quote',
  variant = 'default',
  faqItems = [],
  storySections = []
}) => {
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  return (
    <>
      <Seo title={title} description={description} canonical={canonical} h1={h1} />
      <main className="page-shell max-w-6xl mx-auto px-4 py-16 md:py-20">
        <div className="rounded-3xl bg-white shadow-sm border border-gray-200 p-8 md:p-12">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#3f9422]">Prime Lawn & Snow Management</p>
          <h1 className="page-title text-4xl md:text-5xl font-black text-gray-900 mt-4 mb-6">{h1}</h1>

          {variant === 'faq' && (
            <div className="space-y-4">
              {faqItems.map((item, index) => {
                const isOpen = openFaqIndex === index;
                return (
                  <div key={item.question} className="overflow-hidden rounded-2xl border border-gray-200 bg-[#f7faf5]">
                    <button
                      type="button"
                      onClick={() => setOpenFaqIndex(isOpen ? -1 : index)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-lg font-semibold text-gray-900"
                    >
                      <span>{item.question}</span>
                      <span className="text-2xl text-[#3f9422]">{isOpen ? '−' : '+'}</span>
                    </button>
                    {isOpen && (
                      <div className="border-t border-gray-200 px-5 py-4 text-gray-700 leading-7">
                        {item.answer}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {variant === 'story' && (
            <div className="space-y-8">
              <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
                <div className="space-y-5">
                  {content.map((paragraph, index) => (
                    <p key={index} className="text-lg leading-8 text-gray-700">{paragraph}</p>
                  ))}
                </div>
                <img
                  src="/images/offer.jpg"
                  alt="Prime Lawn & Snow Management team member working outdoors"
                  className="h-[320px] w-full rounded-3xl object-cover shadow-lg"
                />
              </div>

              <div className="grid gap-6 md:grid-cols-2">
                {storySections.map((section) => (
                  <div key={section.title} className="overflow-hidden rounded-2xl border border-gray-200 bg-[#f7faf5] shadow-sm">
                    {section.image && (
                      <img src={section.image} alt={section.title} className="h-52 w-full object-cover" />
                    )}
                    <div className="p-6">
                      <h2 className="text-xl font-bold text-gray-900 mb-3">{section.title}</h2>
                      <p className="text-gray-700 leading-7">{section.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {variant === 'default' && (
            <div className="prose prose-lg max-w-4xl text-gray-700 leading-8 space-y-5">
              {content.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          )}

          {variant !== 'faq' && variant !== 'story' && content.length > 0 && (
            <div className="prose prose-lg max-w-4xl text-gray-700 leading-8 space-y-5 mt-4">
              {content.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          )}

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="/contact-us"
              className="inline-flex items-center justify-center rounded-full bg-[#3f9422] px-6 py-3 text-base font-semibold text-white shadow-md transition hover:bg-[#2e7a1b]"
            >
              {ctaText}
            </a>
            <a
              href="/moving-services"
              className="inline-flex items-center justify-center rounded-full border border-[#3f9422] bg-white px-6 py-3 text-base font-semibold text-[#3f9422] transition hover:bg-green-50"
            >
              Explore Services
            </a>
          </div>
        </div>
      </main>
    </>
  );
};

export default ContentPage;
